export default "__VITE_ASSET__BxWANCTp__"